import { automateAriaExpandedElements } from "./Accesibility/Expanded";
import { _addEventListener } from "./eventHelper";
import { automateAriaSelectedElements } from "./Accesibility/Selected";

export const a11yInitHelper = () => {
    automateAriaSelectedElements();
    automateAriaExpandedElements();
    automateAriaCheckedInputs();
};

const automateAriaCheckedInputs = () => {
    let ariaCheckedElements = document.querySelectorAll("[data-aria-checked-input]");
    ariaCheckedElements.forEach((ariaCheckedElement) => {
        _addEventListener(ariaCheckedElement, "change", (event) => {
            handleAriaCheckedChange(event);
        });
    });
};

const handleAriaCheckedChange = (event) => {
    let changedInput = event.currentTarget;
    let groupBox = changedInput.closest('[role="radiogroup"]');
    if (groupBox) {
        groupBox.querySelectorAll("[aria-checked]").forEach((ariaCheckedBlock) => {
            ariaCheckedBlock.setAttribute("aria-checked", "false");
        });
    }
    let ariaCheckedBlock = document.querySelector(
        '[data-aria-checked-block="' + changedInput.getAttribute("data-aria-checked-input") + '"]'
    );
    if (ariaCheckedBlock) {
        ariaCheckedBlock.setAttribute(
            "aria-checked",
            ariaCheckedBlock.getAttribute("aria-checked") === "true" ? "false" : "true"
        );
    }
};
export const setFocusOnCookieConsentWhenLoaded = () => {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            const newsletterModal = document.querySelector("body>div>.needsclick");
            if (newsletterModal) {
                const cookieConsent = document.getElementById("shopify-pc__banner__btn-accept");
                if (cookieConsent) {
                    cookieConsent.focus();
                }
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.getElementById("shopify-pc__banner__btn-accept")?.addEventListener("click", function () {
        observer.disconnect();
    });
};

export const disableAttributes = (attributeName, parent = null) => {
    parent = parent ?? document;
    parent.querySelectorAll("[" + attributeName + '="true"]').forEach((element) => {
        disableAttribute(element, attributeName);
    });
};

export const disableAttribute = (element, attributeName) => {
    element.setAttribute(attributeName, "false");
    const controlledElement = document.getElementById(element.getAttribute("aria-controls"));
    controlledElement?.setAttribute("aria-hidden", true);
};

export const toggleStateElement = (element, attributeName) => {
    const isStated = element.getAttribute(attributeName) !== "true";
    element.setAttribute(attributeName, isStated);
    const controlledElement = document.getElementById(element.getAttribute("aria-controls"));
    controlledElement?.setAttribute("aria-hidden", !isStated);
};
